/**
 * 레거시 hreConfMngList.jsp + HreConfMngVO 필터 파라미터 전송 패턴
 *
 * - findDeptId: 파이프(|) 구분 — FULL_DEPT_ID REGEXP
 * - findDeptIds / findUserIds / findJobIds 등: String 콤마 구분
 *   (HreConfMngServiceImpl: getFindXxxIds().split(",") → Array)
 * - findDeptIds (엑셀 일부): 파이프(|) join — selectUserGrpExcelDownload.do
 */

export const normalizeFilterValues = (values?: Array<string | number | null | undefined>) =>
  (values || []).map(v => String(v ?? '')).filter(Boolean);

/** HreConfMngVO findXxxIds(String) — 콤마 구분 문자열로 전송 후 서버에서 split(",") */
export const appendLegacyMultiSelectParam = (
  params: URLSearchParams,
  key: string,
  values?: Array<string | number | null | undefined>,
) => {
  const arr = normalizeFilterValues(values);
  if (!arr.length) {
    params.append(key, '');
    return;
  }
  params.append(key, arr.join(','));
};

/** Step05/07 AJAX 검색 — findDeptId 파이프 + findDeptIds 콤마 */
export const appendLegacyDeptAjaxFilterParams = (
  params: URLSearchParams,
  deptIds?: Array<string | number | null | undefined>,
) => {
  const arr = normalizeFilterValues(deptIds);
  if (!arr.length) {
    params.append('findDeptIds', '');
    params.append('findDeptId', '');
    return;
  }
  params.append('findDeptId', arr.join('|'));
  appendLegacyMultiSelectParam(params, 'findDeptIds', arr);
};

/** Step07 엑셀 — f.findDeptIds.value = val().join("|") */
export const appendLegacyDeptExcelFilterParams = (
  params: URLSearchParams,
  deptIds?: Array<string | number | null | undefined>,
) => {
  const arr = normalizeFilterValues(deptIds);
  if (!arr.length) {
    params.append('findDeptIds', '');
    return;
  }
  params.append('findDeptIds', arr.join('|'));
};

/** Step05 엑셀 form 객체 — hidden input .val() 과 동일(배열 → 문자열 시 콤마) */
export const assignLegacyDeptExcelFormFields = (
  formData: Record<string, unknown>,
  deptIds?: Array<string | number | null | undefined>,
) => {
  const arr = normalizeFilterValues(deptIds);
  if (!arr.length) return;
  formData.findDeptIds = arr;
  formData.findDeptId = arr.join('|');
};

export const assignLegacyMultiSelectFormField = (
  formData: Record<string, unknown>,
  key: string,
  values?: Array<string | number | null | undefined>,
) => {
  const arr = normalizeFilterValues(values);
  if (!arr.length) return;
  formData[key] = arr;
};
